import { openPaywall } from "./paywall";

// The app supplies the current workspace's billing authority without coupling
// shared controls or the API transport to React or the billing feature.
let getPlan: (spaceID?: string) => string | undefined = () => undefined;

export function setCreditPlanGetter(getter: typeof getPlan): void {
  getPlan = getter;
}

export function getCreditPlan(spaceID?: string): string | undefined {
  return getPlan(spaceID);
}

export function openCreditPaywall(): void {
  openPaywall({ kind: "credits", plan: "creator" });
}

/** Unknown access is resolved by the API guard; never guess that it is free. */
export function allowCreditAction(): boolean {
  if (getCreditPlan() !== "free") return true;
  openCreditPaywall();
  return false;
}
